// extracted by mini-css-extract-plugin
export default {"-large":"xy811uViSJgszelCoT9z","webpage":"uaTwDxX3rMcgPSubPkHB","editorWithoutNav":"YaqB2CZBlYQQ__iclNOP","whiteboard":"_4C0y8tir9tDpRL9BYzrB","relative":"bQqVSDqxunk2DurH2qaQ"};